<template>
    <footer class="bg-dark text-white text-center p-2">
      <small>&copy; 2025 MyApp. All rights reserved.</small>
    </footer>
  </template>
  
  <script lang="ts">
  import { defineComponent } from "vue";
  
  export default defineComponent({});
  </script>
  